module.exports = __webpack_public_path__ + "img/ewe.b616f78e.svg";